import PageWrapper from '../components/basic/PageWrapper';

import HeroSection from '../components/components/ContactUsPage/HeroSection';
import AddressSection from '../components/components/ContactUsPage/AddressSection';
import ContactForm from '../components/components/ContactUsPage/ContactForm';
import ContactPageHelmet from '../components/components/ContactUsPage/ContactPageHelmet';

const ContactUsPage = () => {
  return (
    <>
      <ContactPageHelmet />
      <PageWrapper>
        <HeroSection />

        <AddressSection />

        <ContactForm />
      </PageWrapper>
    </>
  );
};

export default ContactUsPage;
